import React from "react";
import { Card } from "antd";

const Settings = () => {
  return (
    <Card title="تنظیمات پنل" style={{ margin: 16 }}>
      <p>در این بخش می‌توانید تنظیمات کلی سیستم را تغییر دهید.</p>
    </Card>
  );
};

export default Settings;
